import {
  AbstractControl,
  UntypedFormArray,
  ValidationErrors,
  ValidatorFn,
} from '@angular/forms';

export const merchantTypesValidator: ValidatorFn = (
  control: AbstractControl
): ValidationErrors | null => {
  return (control as UntypedFormArray).controls?.some(
    (control) => control?.value['merchantType']
  )
    ? null
    : { merchantTypeValidator: true };
};
